import { useSelector } from 'react-redux';
import { getBaccaratHandsCard } from '../selectors';

export const useGameHandsCard = () => useSelector(getBaccaratHandsCard);
